var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDrProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "DrProfile",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1053",
    "data-name": "Group 1053"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_293",
    "data-name": "Ellipse 293",
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#97bedb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1052",
    "data-name": "Group 1052",
    transform: "translate(8.721 7.684)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30162",
    "data-name": "Path 30162",
    d: "M215.847,227.492a7.614,7.614,0,0,1,1.993.579,3.593,3.593,0,0,1,1.609,1.787,3.762,3.762,0,0,1,.281,1.531c-.008.675,0,1.351,0,2.027,0,.132-.029.18-.172.179-.814-.007-1.628,0-2.442,0a.765.765,0,0,1-.161-.035l.324-.239a.386.386,0,0,0,.064-.052.841.841,0,0,0-.388-1.3q0-1.124,0-2.249l-1.107-2.222",
    transform: "translate(-205.857 -216.963)",
    fill: "#eeedee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30163",
    "data-name": "Path 30163",
    d: "M1.4,234.305c-.41,0-.82,0-1.23,0-.118,0-.161-.03-.16-.155,0-.8-.027-1.607.011-2.408a3.449,3.449,0,0,1,.931-2.212A3.653,3.653,0,0,1,2.994,228.4c.286-.057.574-.1.862-.156-.026.064-.047.129-.078.19q-.5,1-.994,2,0,.708,0,1.416A1.589,1.589,0,0,0,1.434,233.2c-.042.364-.026.736-.036,1.1",
    transform: "translate(0 -217.678)",
    fill: "#eeedee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30164",
    "data-name": "Path 30164",
    d: "M121.3,244.928h-1.1l-.221-1.384c-.066-.406-.134-.811-.2-1.218-.08-.525-.154-1.052-.234-1.577-.069-.457-.144-.913-.216-1.37.132.082.264.162.395.245a1.794,1.794,0,0,0,1.464.255,3.5,3.5,0,0,0,.943-.49c-.034.261-.063.523-.1.783-.133.876-.27,1.752-.4,2.628-.038.247-.071.5-.107.743l-.221,1.384",
    transform: "translate(-113.811 -228.301)",
    fill: "#36a9d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30165",
    "data-name": "Path 30165",
    d: "M166.632,220.679c.036-.248.069-.5.107-.743.134-.876.271-1.752.4-2.628.039-.26.068-.522.1-.783a.8.8,0,0,0,.036-.111c.057-.335.112-.671.168-1.006.243,0,.486-.008.727.006a.86.86,0,0,1,.733.552l1.107,2.222-.549,0c-.219,0-.439.008-.658,0-.134-.008-.187.045-.2.166-.071.51-.148,1.02-.214,1.531-.032.246-.024.269-.264.243a1.391,1.391,0,0,0-1.113.34,2.266,2.266,0,0,1-.383.22",
    transform: "translate(-158.92 -205.436)",
    fill: "#d8e0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30166",
    "data-name": "Path 30166",
    d: "M62.893,216.57c.072.456.146.913.216,1.369.08.525.154,1.052.234,1.577.062.406.13.812.2,1.218a1.246,1.246,0,0,1-.225-.115,1.635,1.635,0,0,0-1.357-.44c-.118.022-.155-.054-.17-.144-.029-.187-.05-.375-.076-.562-.049-.357-.1-.715-.147-1.072-.016-.121-.07-.174-.2-.166-.219.013-.439,0-.658,0l-.549,0q.5-1,.994-2c.03-.061.052-.127.078-.19.089-.118.173-.239.268-.352a.711.711,0,0,1,.568-.236c.218,0,.436,0,.655,0l.177,1.107",
    transform: "translate(-57.37 -205.491)",
    fill: "#d9e0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30167",
    "data-name": "Path 30167",
    d: "M162.086,277.828a2.27,2.27,0,0,0,.383-.22,1.391,1.391,0,0,1,1.113-.34c.239.026.232,0,.264-.243.066-.511.143-1.021.214-1.531.017-.121.07-.174.2-.166.219.013.439,0,.658,0q0,1.125,0,2.25a.848.848,0,0,0,0,1.593.765.765,0,0,1-.161.035q-1.446,0-2.892,0l.221-1.384",
    transform: "translate(-154.373 -262.585)",
    fill: "#eeeded"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30168",
    "data-name": "Path 30168",
    d: "M114.172,203.807,114,202.7l-.074-.619a.435.435,0,0,1,.135.013,3.625,3.625,0,0,0,3.065,0,.432.432,0,0,1,.135-.012l-.079.618c-.056.335-.111.671-.168,1.006a.8.8,0,0,1-.036.111,3.5,3.5,0,0,1-.943.49,1.794,1.794,0,0,1-1.464-.255c-.13-.084-.263-.164-.395-.245",
    transform: "translate(-108.649 -192.728)",
    fill: "#eda990"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30169",
    "data-name": "Path 30169",
    d: "M72.015,275.332c.219,0,.439.008.658,0,.134-.008.187.045.2.166.048.357.1.715.147,1.072.026.187.046.375.076.562.014.091.052.166.17.145a1.635,1.635,0,0,1,1.357.44,1.245,1.245,0,0,0,.225.115l.221,1.384H73.4c0-.277,0-.554,0-.831a1.666,1.666,0,0,0-1.134-1.574c-.085-.029-.169-.062-.254-.094q0-.69,0-1.381",
    transform: "translate(-68.682 -262.584)",
    fill: "#eeeded"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30170",
    "data-name": "Path 30170",
    d: "M44.317,319.07H42.1c0-.294,0-.587,0-.881a1.022,1.022,0,0,1,.363-.773,1.06,1.06,0,0,1,1.233-.172,1.074,1.074,0,0,1,.62,1.031c0,.265,0,.53,0,.794",
    transform: "translate(-40.147 -302.442)",
    fill: "#eeeded"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30171",
    "data-name": "Path 30171",
    d: "M32.981,307.78c0-.265,0-.53,0-.795a1.074,1.074,0,0,0-.62-1.031,1.06,1.06,0,0,0-1.233.172,1.022,1.022,0,0,0-.363.773c-.007.293,0,.587,0,.881h-.551c.01-.368-.006-.739.036-1.1A1.589,1.589,0,0,1,31.6,305.32l.549-.038c.085.031.168.065.254.094a1.667,1.667,0,0,1,1.134,1.574c0,.277,0,.554,0,.831h-.551",
    transform: "translate(-28.811 -291.153)",
    fill: "#c1c1c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30174",
    "data-name": "Path 30174",
    d: "M216.385,325.062a.848.848,0,0,1,0-1.593l.208-.029a.8.8,0,0,0-.129.9.823.823,0,0,0,.8.48l-.324.239h-.553",
    transform: "translate(-205.84 -308.47)",
    fill: "#565656"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30175",
    "data-name": "Path 30175",
    d: "M228.091,277.672l-.208.029q0-1.125,0-2.25l.549,0q0,1.124,0,2.249l-.342-.03",
    transform: "translate(-217.336 -262.702)",
    fill: "#373737"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30176",
    "data-name": "Path 30176",
    d: "M227.932,323.44l.342.03a.841.841,0,0,1,.388,1.3.379.379,0,0,1-.064.052.823.823,0,0,1-.8-.48.8.8,0,0,1,.13-.9",
    transform: "translate(-217.177 -308.47)",
    fill: "#808181"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30177",
    "data-name": "Path 30177",
    d: "M60.7,276.832l-.549.038q0-.708,0-1.416l.549,0q0,.69,0,1.381",
    transform: "translate(-57.37 -262.702)",
    fill: "#373737"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30180",
    "data-name": "Path 30180",
    d: "M79.254,80.685a8.753,8.753,0,0,1-.218.933,3.509,3.509,0,0,1-1.58,1.908.773.773,0,0,0-.138.14.43.43,0,0,0-.135.013,3.625,3.625,0,0,1-3.065,0,.432.432,0,0,0-.135-.013.977.977,0,0,0-.154-.148,3.614,3.614,0,0,1-1.711-2.4c-.032-.145-.048-.293-.071-.44q0-.157,0-.314a2.44,2.44,0,0,1,.031-.357c.1-.439.212-.876.321-1.313.066-.264.135-.526.2-.779a2.421,2.421,0,0,1,.242.031,15.873,15.873,0,0,0,2.4.376q1.007.081,2.016.136c.328.017.658,0,.987,0,.47,0,.476,0,.619.451.134.425.258.853.376,1.283a2.944,2.944,0,0,1,.055.412l-.033.074",
    transform: "translate(-68.71 -74.313)",
    fill: "#fad9be"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30181",
    "data-name": "Path 30181",
    d: "M61.854,6.3a2.944,2.944,0,0,0-.055-.412c-.118-.43-.242-.858-.376-1.283-.143-.453-.149-.451-.619-.451-.329,0-.659.014-.987,0Q58.809,4.1,57.8,4.013a15.873,15.873,0,0,1-2.4-.376,2.407,2.407,0,0,0-.242-.031c-.065.253-.134.515-.2.779-.109.437-.219.874-.321,1.313a2.447,2.447,0,0,0-.03.357.879.879,0,0,1-.1-.147c-.174-.4-.344-.8-.515-1.2A7.088,7.088,0,0,1,53.8,3.7a2.5,2.5,0,0,1,.245-1.744,1.639,1.639,0,0,1,.656-.524,2.351,2.351,0,0,0,.521-.335A4.523,4.523,0,0,1,57.308.1,5.286,5.286,0,0,1,58.339,0a4.736,4.736,0,0,1,2.049.462,3.828,3.828,0,0,1,1.969,1.892,3.573,3.573,0,0,1,.269,1.079,3.438,3.438,0,0,1-.14,1.3c-.027.087-.047.177-.082.26-.182.435-.367.868-.551,1.3",
    transform: "translate(-51.276 -0.001)",
    fill: "#373737"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30182",
    "data-name": "Path 30182",
    d: "M42.905,101.681c.171.4.341.8.515,1.2a.88.88,0,0,0,.1.147q0,.157,0,.314a4.352,4.352,0,0,1-.721-.022.812.812,0,0,1-.665-.859.86.86,0,0,1,.764-.782",
    transform: "translate(-40.19 -96.975)",
    fill: "#eea990"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30183",
    "data-name": "Path 30183",
    d: "M227.854,103.9c.184-.434.37-.867.551-1.3.035-.084.055-.173.082-.26a.8.8,0,0,1,.665,1.013.821.821,0,0,1-.813.62l-.518,0,.033-.074",
    transform: "translate(-217.277 -97.605)",
    fill: "#eda990"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrProfile);
export default __webpack_public_path__ + "static/media/DrProfile.a2d4c108d89d26d9ac21381258db3e94.svg";
export { ForwardRef as ReactComponent };